export default {"src":"/_next/static/media/payload.0d2351e3.svg","height":305,"width":256,"blurWidth":0,"blurHeight":0};